import { render, staticRenderFns } from "./Famille.vue?vue&type=template&id=d71c4736&scoped=true&"
import script from "./Famille.vue?vue&type=script&lang=js&"
export * from "./Famille.vue?vue&type=script&lang=js&"
import style0 from "./Famille.vue?vue&type=style&index=0&id=d71c4736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71c4736",
  null
  
)

export default component.exports